// extracted by mini-css-extract-plugin
export default {"item":"empty-environment_item__PVGAR","captionContainer":"empty-environment_captionContainer__OHBLx","caption":"empty-environment_caption__vdL7d"};